export default __webpack_public_path__ + "static/media/0039865131.29c37129.pdf";